module.exports = __webpack_public_path__ + "img/4-5.0db66b38.svg";